import { EDIT_SPONSORS_LOADING, EDIT_SPONSORS_SUCCESS, EDIT_SPONSORS_ERROR } from "../../../constant/actionTypes";

const editSponsorReducer = (state = {}, action) => {
    switch (action.type) {
        case EDIT_SPONSORS_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case EDIT_SPONSORS_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response,
            };
            return obj;
        }
        case EDIT_SPONSORS_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default editSponsorReducer;